module.exports = __webpack_public_path__ + "static/img/2.75db392.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/6/eng/2.png
// module id = 4+Gt
// module chunks = 0